export enum LearningHistoryRange {
  day = "day",
  yesterday = "yesterday",
  three_days = "three_days",
  week = "week",
  month = "month",
  all = "all",
}
